import queryString from "query-string";
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import { TabelHeadingTxt } from "../../Text/TabelCommonTxt";
import { Divider, Text } from "theme-ui";
import DataTable from "../../Tabels/Tabel";
import { ColumnDef } from "@tanstack/react-table";
import moment from "moment";
import { getAllNotificationByEmail } from "../../../store/actions/login.action";

const Notificationview = () => {
    const { auther, allNotifications, loader } = useSelector((state: any) => state.auth);
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams({
        currentPage: "1",
        limit: "15",
    });

    const limit = parseInt(searchParams.get('limit') || "15");
    const currentPage = parseInt(searchParams.get('currentPage') || "1");

    const dispatch = useDispatch();
    const [refresh, setRefresh] = useState<boolean>(true);
    // console.log('chk29', auther);

    const email = auther?.Email;

    useEffect(() => {
        if (!email || !refresh) return;

        const obj = {
            email,
            currentPage,
            limit,
            // read: false
        };

        dispatch(getAllNotificationByEmail(obj)); // not a URL string!
        setRefresh(false);
    }, [refresh, location?.search, limit, currentPage, email]);


    const columns = useMemo<ColumnDef<any>[]>(() => [
        {
            header: 'No',
            enableColumnFilter: false,
            accessorKey: "no",
            cell: ({ row }) => {
                return (
                    <Text variant='Poppins14Normal24lh'>{((currentPage - 1) * limit) + row?.index + 1}</Text>
                )
            },
        },
        {
            accessorKey: "emailId",
            header: 'Email',
            cell: ({ row }) => {

                return (
                    <Text>{row?.original?.emailId}</Text>
                )
            },
            enableColumnFilter: true,
            // filterType: "textbox",
        },
        {
            accessorKey: "message",
            header: 'Message',
            cell: ({ row }) => (
                <Text>{row?.original?.message}</Text>
            ),
            enableColumnFilter: true,
            // filterType: "textbox",
        },

        {
            header: 'Project Name',
            accessorKey: "projectId",
            cell: ({ row }) => (
                <Text>{row.original?.projectId?.name}</Text>
            ),
            // filterType: 'dropdown',
            // options: dataForTable?.data?.allProjects?.map((val: { _id: string, name: string }) => ({ value: val._id, label: val.name }))
        },


        {
            header: 'Created By',
            accessorKey: "createdBy",
            cell: ({ row }) => {
                const fullName = row?.original?.createdBy?.FirstName + ' ' + row?.original?.createdBy?.LastName;
                return (
                    <Text>{fullName}</Text>

                )
            },
            // filterType: "dropdown",
            // options: userOptions
        },
        {
            header: 'Created Date',
            accessorKey: "createdAt",
            cell: ({ row }) => {
                const createdDateValue = row.original?.createdAt;
                return (
                    <Text variant='Poppins14Normal24lh'>{createdDateValue ? moment(createdDateValue.split('T')[0]).format("MMM DD, YYYY") : ""}</Text>
                );
            },
            // filterType: 'date',
        },

    ], [allNotifications]);
    return (
        <div className='main-content'>
            <TabelHeadingTxt Title='Notifications' Count={''} IsExportButtonShow={false} onClick={() => { }} sx={{ backgroundColor: '#7743DB', color: 'white' }} />
            <Divider sx={{ color: '#D9D7DD' }} opacity={2} my={[3, 3, 4]} />
            <DataTable
                loader={loader}
                columns={columns}
                data={allNotifications?.data || []}
                TotalLength={allNotifications?.count || 15}
                perPageCount={limit || 15}
                currentPage={currentPage || 1}
                onPerPageChange={(itemsPerPage) => {
                    const parsedQuery = queryString.parse(location.search);

                    setSearchParams({
                        ...parsedQuery,
                        currentPage: '1',
                        limit: itemsPerPage.toString(),
                    });
                    setRefresh(true);
                }}
                onPageChange={(value: string) => {
                    const parsedQuery = queryString.parse(location.search);

                    setSearchParams({
                        ...parsedQuery,
                        currentPage: value.toString(),
                        limit: limit.toString(),
                    });
                    setRefresh(true);
                }}
            />

        </div>
    )
}

export default Notificationview